import React from 'react';
import { useTranslation } from 'react-i18next';
import './DonationForm.css';

const DonationForm = () => {
  const { t } = useTranslation();

  return (
    <section className="donation-form-section section-padding">
      <div className="container">
        <div className="donation-form-wrapper fade-up">
          <div className="donation-form-header">
            <h2>{t('donation_form_make_donation_title')}</h2>
            <p>{t('donation_form_make_donation_description')}</p>
          </div>
          <div className="qr-code-container-donation">
            <img
              src={`${process.env.PUBLIC_URL || ''}/images/qrcode.jpg`}
              alt="Scan to donate using the Atmasakshi Foundation QR code"
              className="qr-code-image-donation"
            />
           <p className="qr-code-acccount">{t('donation_form_account_label')} <span>{t('donation_form_account_value')}</span></p>
            <p className="qr-code-ifsc">{t('donation_form_ifsc_label')} <span>{t('donation_form_ifsc_value')}</span></p>
            <p className="qr-code-caption-donation">{t('donation_form_scan_to_donate')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DonationForm;
